import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable()
export class Logged implements Resolve<any> {
	constructor(
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
		if (this.authService.isLogged()) {
			this.router.navigate(['/dashboard']);
		}
	}
}
